import {
  Favorable,
  OnDemandContentType
} from '@norlys-a-s/norlys-play-kmm/kotlin/NorlysPlay_KMM-shared.mjs';

import { ContentType } from '@smart-tv/typings/content';

import { kmm } from './kmm';

export type Payload = {
  contentId: number;
  setContentActive: boolean;
  contentType: ContentType.Movies | ContentType.Series;
};

const contentTypeMap: Record<Payload['contentType'], OnDemandContentType> = {
  [ContentType.Movies]: OnDemandContentType.CONTENT_TYPE_MOVIE,
  [ContentType.Series]: OnDemandContentType.CONTENT_TYPE_SERIES
};

const mapContentTypeToOnDemandContentType = (
  contentType: Payload['contentType']
): OnDemandContentType => contentTypeMap[contentType];

export const setFavoriteContent = async (payload: Payload): Promise<boolean> => {
  const favorable = new Favorable(
    payload.contentId,
    mapContentTypeToOnDemandContentType(payload.contentType)
  );

  const data = await kmm((repo) => repo.setFavoriteContent(favorable, payload.setContentActive));

  return data;
};

export default setFavoriteContent;
